// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1fd59d29","977":"ab4e19d8"}[chunkId] + ".chunk.js";
};